import { isValidEmail } from '@domain-group/javascript-utils'

const state = {
  address_line_1: '',
  address_line_2: '',
  address_postcode: '',
  address_region: '',
  address_state: '',
  company_name: '',
  connection_id: '',
  connection_type: '',
  contact_type: 'vendor',
  country_calling_code: '+61',
  email: '',
  first_name: '',
  id: null,
  last_name: '',
  legal_name: '',
  mobile: '',
  phone: '',
}

export const requiredFields = [
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'first_name' },
  { key: 'last_name' },
]

export default state
